import { ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { isNull } from 'lodash';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { BudgetCurrencyType } from '@shared/store/budget-currency/budget-currency.model';
import { BudgetCurrencyQuery } from '@shared/store/budget-currency/budget-currency.query';
import { AgSetColumnsVisible } from '@shared/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, AsyncPipe],
  templateUrl: './ag-header-actions.component.html',
})
export class AgHeaderActionsComponent {
  private budgetCurrencyQuery = inject(BudgetCurrencyQuery);

  change$ = new BehaviorSubject(true);
  params!: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;

    if (
      !isNull(this.params.context) &&
      Object.prototype.hasOwnProperty.call(this.params.context, 'isExpanded')
    ) {
      this.change$.next(this.params.context.isExpanded);
    } else {
      this.params.api.setGridOption('context', { isExpanded: true });
    }
  }

  onChangeClick() {
    if (this.budgetCurrencyQuery.getValue().currency === BudgetCurrencyType.USD) {
      AgSetColumnsVisible({
        gridApi: this.params.api,
        keys: [
          'investigator_contract_amount',
          'passthrough_contract_amount',
          'service_contract_amount',
          'discount_contract_amount',
          'investigator_amount',
          'passthrough_amount',
          'service_amount',
          'discount_amount',
        ],
        visible: !this.change$.getValue(),
      });
    } else {
      AgSetColumnsVisible({
        gridApi: this.params.api,
        keys: [
          'investigator_contract_amount',
          'passthrough_contract_amount',
          'service_contract_amount',
          'discount_contract_amount',
        ],
        visible: !this.change$.getValue(),
      });
    }

    this.change$.next(!this.change$.getValue());
    this.params.api.setGridOption('context', { isExpanded: this.change$.getValue() });
  }
}
